import { appConfig } from '@mse-reg/config';
import { Grid } from '@mui/material';
import { NavLink as Link } from 'react-router-dom';
import { BrandIcon } from './brand-icon';

export const Brand = () => {
  return (
    <Link to="/" style={{ textDecoration: 'none' }}>
      <Grid container spacing={0} alignItems="center">
        <Grid
          sx={{
            visibility: { xs: 'hidden', md: 'visible' },
            display: { xs: 'none', md: 'inherit' },
          }}
        >
          <BrandIcon />
        </Grid>
        <Grid
          sx={{
            '&:hover': {
              textDecoration: 'none',
            },
            color: '#fff',
            fontSize: { xs: 10, md: 24 },
          }}
        >
          MSE Admin Engine
        </Grid>
        <Grid
          sx={{
            fontSize: 12,
            color: '#fff',
            marginLeft: 2,
          }}
        >
          <>v{appConfig.VERSION}</>
        </Grid>
      </Grid>
    </Link>
  );
};
